import React from 'react';

/** Inline "label value" fact for detail-page headers (PageHeader `meta`). */
export default function DetailFact({ icon, label, children }) {
    return (
        <span className="inline-flex items-center gap-1.5 text-[13px] text-surface-500">
            {icon && <span className="flex text-surface-400">{icon}</span>}
            <span>{label}</span>
            <span className="font-medium text-surface-700 tabular-nums">{children}</span>
        </span>
    );
}
